<template>
<section class="weather-information-detail">
	<h1 class="weather-information-detail__title"><i class="weather-information-detail__close" @click="onClickCloseIcon" />台風情報・進路予想</h1>
	<!-- NOTE: 今後、台風以外も表示する予定 -->
	<!-- 台風詳細 -->
	<section v-if="computedTyphoonDetail" class="typhoon-information-detail">
		<h2 class="typhoon-information-detail__title">
			<em class="typhoon-information-detail__title--name">{{ computedTyphoonDetail.typhoon_name }}</em>
			<span class="typhoon-information-detail__title--datetime">{{ computedTyphoonDetail.issue_date}}発表</span>
		</h2>
		<p class="typhoon-information-detail__img">
			<span class="typhoon-information-detail__img--inner">
				<img :src="computedTyphoonDetail.image" alt="台風進路予想図">
			</span>
			<span class="typhoon-information-detail__img--annotation">※台風が日本から遠く離れている場合、地図上に表示されないことがあります。</span>
		</p>

		<aside class="typhoon-information-detail__accordion" @click="isAccordionClose = !isAccordionClose">
			<h3 class="typhoon-information-detail__accordion--title"><span>台風進路予想図の見方</span><v-ons-icon :icon="isAccordionClose ? 'md-chevron-down' : 'md-chevron-up'" /></h3>
			<transition name="accordion">
				<div v-if="!isAccordionClose" class="typhoon-information-detail__accordion--inner">
					<ul class="typhoon-information-detail__accordion--list">
						<li class="typhoon-information-detail__accordion--item"><em>強風域：</em><span>最大風速15m/s以上</span></li>
						<li class="typhoon-information-detail__accordion--item"><em>暴風域、暴風警戒域：</em><span>最大風速25m/s以上</span></li>
						<li class="typhoon-information-detail__accordion--item"><em>予報円：</em><span>台風の中心が予報円に入る確率が70%</span></li>
					</ul>
					<p class="typhoon-information-detail__accordion--text">※台風の中心が予報円の中心を結ぶ点を必ずしも進むわけではありません</p>
				</div>
			</transition>
		</aside>

		<section class="typhoon-information-detail__summary">
			<h4 class="typhoon-information-detail__summary--title"><span>台風概況</span></h4>
			<p v-if=" computedTyphoonDetail.summary === ''" class="typhoon-information-detail__summary--text is-empty">発表された場合に随時更新いたします。</p>
			<p v-else class="typhoon-information-detail__summary--text">{{ computedTyphoonDetail.summary }}</p>
		</section>

		<h3 class="typhoon-information-detail__observation--title">進路予想</h3>
		<section class="typhoon-information-detail__observation">
			<h4 class="typhoon-information-detail__list--title">{{ computedTyphoonDetail.observation.datetime }}</h4>
			<dl class="typhoon-information-detail__list">
				<dt class="typhoon-information-detail__list--headline">大きさ</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.size }}</dd>
				<dt class="typhoon-information-detail__list--headline">中心気圧</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.pressure }}</dd>
				<dt class="typhoon-information-detail__list--headline">強さ</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.strength }}</dd>
				<dt class="typhoon-information-detail__list--headline">最大風速 <br>(瞬間)</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.maxwind }}</dd>
				<dt class="typhoon-information-detail__list--headline">方向・速度</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.movement }}</dd>
				<dt class="typhoon-information-detail__list--headline">存在地域</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.location }}</dd>
				<dt class="typhoon-information-detail__list--headline">緯度</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.lat }}</dd>
				<dt class="typhoon-information-detail__list--headline">経度</dt>
				<dd class="typhoon-information-detail__list--item">{{ computedTyphoonDetail.observation.lon }}</dd>
			</dl>
		</section>
		<section
			v-for="(item, index) in computedTyphoonDetail.forecast"
			:key="`typhoon-${index}`"
			:class="[
				'typhoon-information-detail__forecast',
				{ 'is-extratropical-cyclone': item.class === '温帯低気圧' || item.class === '熱帯低気圧' }
			]"
		>
			<h4 class="typhoon-information-detail__list--title">{{ item.datetime }}</h4>
			<dl class="typhoon-information-detail__list">
				<dt class="typhoon-information-detail__list--headline">大きさ</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.size }}</dd>
				<dt class="typhoon-information-detail__list--headline">中心気圧</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.pressure }}</dd>
				<dt class="typhoon-information-detail__list--headline">強さ</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.strength }}</dd>
				<dt class="typhoon-information-detail__list--headline">最大風速 <br>(瞬間)</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.maxwind }}</dd>
				<dt class="typhoon-information-detail__list--headline">方向・速度</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.movement }}</dd>
				<dt class="typhoon-information-detail__list--headline">存在地域</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.location }}</dd>
				<dt class="typhoon-information-detail__list--headline">緯度</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.lat }}</dd>
				<dt class="typhoon-information-detail__list--headline">経度</dt>
				<dd class="typhoon-information-detail__list--item">{{ item.lon }}</dd>
			</dl>
		</section>

		<aside class="typhoon-information-detail__description">
			※台風情報・進路予想は台風の1日（24時間）先までの12時間刻みの予報を3時間ごとに発表し、さらに5日（120時間）先までの24時間刻みの予報を6時間ごとに発表します。<br>
			※予報の内容は、各予報時刻の台風の中心位置（予報円の中心と半径）、進行方向と速度、中心気圧、最大風速、最大瞬間風速、暴風警戒域です。<br>
			※台風が日本に接近し、影響するおそれがある場合には、台風の位置や強さなどの実況と1時間ごとの推定値を1時間ごとに発表するとともに、24時間先までの3時間刻みの予報を3時間ごとに発表します。
		</aside>
	</section>
	<section v-else class="typhoon-information-detail is-error">
		<common-error-message>データを正常に<br>取得できませんでした</common-error-message>
	</section>
	<!-- /台風詳細 -->
</section>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_TYPHOON_INFORMATION } from '@/store/modules/weatherForecast/mutation-types'
import CommonErrorMessage from '@/components/Molecules/CommonErrorMessage'
import moment from 'moment'

export default {
	name: 'WeatherInformationDetail',
	components: {
		CommonErrorMessage
	},
	data () {
		return {
			isAccordionClose: true
		}
	},
	props: {
		informationNumber: {
			type: String,
			default: ''
		}
	},
	created () {
	},
	computed: {
		...mapGetters('common', ['userId', 'userToken']),
		...mapGetters('weatherForecast', ['typhoonInformationData']),

		computedTyphoonDetail () {
			let typhoonDetail = null

			if (this.typhoonInformationData) {
				typhoonDetail = JSON.parse(JSON.stringify(this.typhoonInformationData.records))	// ディープコピー

				// 発表時刻
				typhoonDetail.issue_date = moment(typhoonDetail.issue_date, 'YYYY年MM月DD日 hh時mm分').format('M月D日H時m分')

				// 観察情報の時刻
				typhoonDetail.observation.datetime = moment(typhoonDetail.observation.datetime).format('YYYY年M月D日H時')

				// 予報情報
				const forecast = typhoonDetail.forecast.map(item => {
					// 時刻
					item.datetime = moment(item.datetime).format('YYYY年M月D日H時')

					// 温帯低気圧・熱帯低気圧
					item.size = (item.class === '温帯低気圧' || item.class === '熱帯低気圧') && item.size === ' --- ' ? item.class : item.size
					item.strength = (item.class === '温帯低気圧' || item.class === '熱帯低気圧') && item.strength === ' --- ' ? item.class : item.strength

					return item
				})
				typhoonDetail.forecast = forecast
			}

			return typhoonDetail
		}
	},
	mounted () {
		const isHasTyphoonNumber = this.typhoonInformationData ? this.typhoonInformationData.records.typhoon_number === this.informationNumber : false

		// 台風情報が空ではない、且つ所持している台風情報の番号と指定された台風番号が異なる場合はリクエスト
		if (this.informationNumber !== '' && !isHasTyphoonNumber) {
			this.SET_TYPHOON_INFORMATION({
				user_id: this.userId,
				user_token: this.userToken,
				typhoon_number: this.informationNumber
			}).then(res => {
				console.log('SET_TYPHOON_INFORMATION res: ', res)
			}).catch(error => {
				// NOTE: エラー処理
				console.log('Error: ', error)
			})
		}
	},
	beforeDestroy () {
	},
	methods: {
		// map Vuex actions
		...mapActions('weatherForecast', [SET_TYPHOON_INFORMATION]),

		onClickCloseIcon () {
			this.$emit('setInformationNumber', '')	// 空の台風番号を親コンポーネントにemitする
		}
	}
}
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/variable";

$spacing-1: 0.062rem;
$spacing-3: 0.187rem;
$spacing-5: 0.312rem;
$spacing-7: 0.437rem;
$spacing-22: 1.375rem;
$color-extratropical-cyclone: #F6B552;
$color-list-extratropical-cyclone: #FBE1B9;
$color-darkgray: #666;
$color-strong-wind-area: #FFDD00;
$color-storm-area: #FEA500;
$color-forecast-circle: #FF0000;
$line-height-13: 1.3;
$letter-spacing-0_4: 0.04em;

.weather-information-detail {
	font-family: $family-primary;
	background-color: $background-primary;
	border-radius: 10px 10px 0 0;
	color: $text-primary;

	h1, h2, h3, h4 {
		font-family: $family-primary;
		font-weight: normal;
	}

	&__title {
		position: relative;
		margin: 0 $spacing-16;
		padding: $spacing-10 0;
		text-align: center;
		font-size: $font-size-18;
		letter-spacing: $letter-spacing-0_4;
		border-bottom: solid 1px $line-primary;
	}

	&__close {
		display: block;
		width: 28px;
		height: 28px;
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		font-size: $font-size-44;
		color: $primary;

		&::before,
		&::after {
			content: '';
			display: block;
			position: absolute;
			background-color: $primary;
			transform: rotate(45deg);
		}

		&::before {
			width: 100%;
			height: 1px;
			top: 50%;
			left: 0;
		}

		&::after {
			width: 1px;
			height: 100%;
			top: 0;
			left: 50%;
		}
	}
}

.typhoon-information-detail {
	padding: 0 0 $spacing-20 0;

	&.is-error {
		position: relative;
		height: calc(100vh - 48px);
		padding: 0;
		background-color: $background-primary;

		/deep/ .common-error-message {
			background: $background-primary;

			&__inner { color: $text-primary; }
			&__icon svg path { fill: $text-primary; }
		}
	}

	&__title {
		margin: $spacing-16 auto 0;
		width: 87.5%;
		font-size: $font-size-12;
		text-align: left;

		&--name {
			display: block;
			font-style: normal;
			font-size: $font-size-16;
			letter-spacing: $letter-spacing-0_4;
		}

		&--datetime {
			display: block;
			margin: $spacing-3 0 0;
			font-family: $lp-family-primary;
			font-size: $font-size-10;
			color: $text-primary;
		}
	}

	&__img {
		width: 87.5%;
		margin: $spacing-6 auto 0;

		&--inner {	// 描画時のガタつきを抑えるため高さを確保しておき、position: absoluteで画像を配置する。
			display: block;
			position: relative;
			width: 100%;
			padding-top: 100%;

			& > img {
				position: absolute;
				display: block;
				max-width: calc(100% - 6px);
				top: 3px;
				left: 3px;
			}

			&::after {	// 画像に残った上左の黒ぶちを消すための枠
				content: '';
				display: block;
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				border: 4px solid $background-list;
				box-sizing: border-box;
			}
		}

		&--annotation {
			display: inline-block;
			font-family: $lp-family-primary;
			margin: $spacing-4 0 0;
			font-size: $font-size-10;
			color: $color-darkgray;
			letter-spacing: $letter-spacing-0_4;
			text-align: left;
		}
	}

	&__accordion {
		margin: $spacing-7 $spacing-20 0;
		border-radius: 5px;
		overflow: hidden;
		border: 2px solid $background-list;
		border-top: none;

		&--title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 0;
			padding: $spacing-3 $spacing-10 $spacing-1 $spacing-8;
			font-size: $font-size-12;
			text-align: left;
			background-color: $background-list;
			border-radius: 5px 5px 0px 0px;
			letter-spacing: $letter-spacing-0_4;

			& > span { line-height: $line-height-1; }

			& > ons-icon {
				font-size: $font-size-20;
				line-height: $line-height-1;
			}
		}

		&--inner {
			padding: $spacing-10 $spacing-8 $spacing-6;
			font-size: $font-size-10;
			border-top: 1px solid $background-list;
			letter-spacing: $letter-spacing-0_4;
		}

		&--list {
			margin: 0;
			padding: 0;
			list-style: none;
			text-align: left;
		}

		&--item {
			display: flex;
			align-items: center;
			line-height: $line-height-1;

			& > em {
				font-style: normal;
				margin-left: $spacing-3;
			}

			& > span { font-family: $lp-family-primary; }

			&::before {
				content: '';
				display: block;
				width: 22px;
				height: 10px;
				border-radius: 3px;
			}
		}

		&--item + &--item { margin: $spacing-5 0 0; }
		&--item:nth-of-type(1)::before { background-color: $color-strong-wind-area; }
		&--item:nth-of-type(2)::before { background-color: $color-storm-area; }
		&--item:nth-of-type(3)::before { background-color: $color-forecast-circle; }

		&--text {
			font-family: $lp-family-primary;
			margin: $spacing-3 0 0;
			text-align: left;
		}
	}

	&__summary {
		margin: $spacing-18 $spacing-10 0;
		padding: 0 0 $spacing-14;
		border-bottom: solid 1px $primary;

		&--title {
			position: relative;
			margin: 0;
			color: $primary;

			& > span {
				position: relative;
				display: inline-block;
				padding: 0 $spacing-6;
				background-color: $background-primary;
				font-size: $font-size-18;
				letter-spacing: $letter-spacing-0_4;
			}

			&::before {
				content: '';
				display: block;
				border-top: solid 1px $primary;
				width: 100%;
				height: 1px;
				position: absolute;
				top: calc(50% + #{$spacing-1});
			}
		}

		&--text {
			font-family: $lp-family-primary;
			margin: $spacing-8 0 0;
			font-size: $font-size-16;
			text-align: left;
			line-height: $line-height;
			letter-spacing: $letter-spacing-0_4;

			&.is-empty { text-align: center; }
		}
	}

	&__observation,
	&__forecast {
		padding: 0 $spacing-10;
		letter-spacing: $letter-spacing-0_4;
	}
	&__forecast { margin: $spacing-20 0 0; }

	&__observation {
		margin: $spacing-7 0 0;

		&--title {
			margin: $spacing-22 $spacing-10 0;
			font-size: $font-size-16;
			line-height: $line-height-1;
			text-align: left;
		}
	}

	&__list {
		display: flex;
		flex-wrap: wrap;
		margin: 0;
		font-size: $font-size-10;

		&--title {
			margin: 0;
			padding: $spacing-4 $spacing-8;
			font-size: $font-size-14;
			color: $text-seconday;
			background-color: $primary;
			text-align: left;
			letter-spacing: $letter-spacing-0_4;
		}

		&--headline,
		&--item {
			padding: $spacing-8 $spacing-2 $spacing-7 $spacing-4;
			box-sizing: border-box;
			text-align: left;
			line-height: $line-height-13;

			&:nth-of-type(n+3) { margin: $spacing-2 0 0 0; }
		}

		&--headline:nth-of-type(even) { margin-left: $spacing-2; }

		&--headline {
			width: calc(20% + #{$spacing-1});
			background-color: $background-list;
		}

		&--item {
			font-family: $lp-family-primary;
			width: calc(30% - #{$spacing-2});	// 見出し横幅に+1pxしたものとマージン1px分を引く
			margin: 0;
			background-color: $background-secondary;
		}
	}

	&__forecast.is-extratropical-cyclone {
		.typhoon-information-detail__list {
			&--title { background-color: $color-extratropical-cyclone; }
			&--item:nth-of-type(1),
			&--item:nth-of-type(3) {
				font-family: $lp-family-tertiary;
				background-color: $color-list-extratropical-cyclone;
			}
		}
	}

	&__description {
		font-family: $lp-family-primary;
		margin: $spacing-16 $spacing-10 0;
		text-align: left;
		font-size: $font-size-10;
		color: $color-darkgray;
		letter-spacing: $letter-spacing-0_4;
	}
}

// トランジション
.accordion-enter-active {
  animation: accordion-in .2s;
}
.accordion-leave-active {
  animation: accordion-in .2s reverse;
}
@keyframes accordion-in {
  0% { height: 0px; }
  100% { height: auto; }
}
</style>
